import React, { useState, useEffect, useContext } from 'react';
import { getBatch } from '../../axios';
import authContext from '../../AuthContext';
import { toast } from 'react-toastify';
import {
  Container,
  TextField,
  Typography,
  Button,
  Box,
  MenuItem,
  Paper,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import imageBaseURL from '../../image';
import { getTotalStudents, getImages ,getAdminImages } from '../../axios';
const GreenButton = styled(Button)({
  backgroundColor: '#4caf50',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#388e3c',
  },
});

const StudentDetailsForm = ({ onSubmit, student }) => {
  //console.log(student);
  const { user, userType, admin } = useContext(authContext);
  const [candidateName, setCandidateName] = useState(student?.name || '');
  const [mobileNo, setMobileNo] = useState(student?.contact || '');
  const [batch, setBatch] = useState(student?.batch_id || '');
  const [address, setAddress] = useState(student?.address || '');
  const [batchOptions, setBatchOptions] = useState([]);
  const [imageFile, setImageFile] = useState(student?.photo1 || null);
  const [availableImages, setAvailableImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(student?.photo1 ||'');
  const [imageFileName, setImageFileName] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(
    student ? `https://ppxxub.online/apis/${student?.photo1}` : null,
  );
  //console.log(`${imageBaseURL}/${student?.photo1 }`)
  const handleImageSelect = (e) => {
    const selected = e.target.value;
    setSelectedImage(selected);
    setImagePreviewUrl(`https://ppxxub.online/apis/${selected}`);
    setImageFile(selected);
  };
  useEffect(() => {
    const fetchImages = async () => {
      try {
       // console.log(user,'user_id',batch,"batch_id")
        const response = await getAdminImages(user ,batch);
        //console.log(response);
        const images = response.data.map(
          (img) => img,
        );
        //console.log(images);
        setAvailableImages(images);
      } catch (error) {
        console.error('Error fetching images:', error);
        toast.error('Failed to fetch images');
      }
    };
    if(user && batch){
      fetchImages()
    }
  }, [refresh ,batch]);
  const handleRefresh = () => {
    setRefresh(!refresh);
  };
  const onBatchSelect = async (e) => {
    const selectedBatchId = e.target.value; // ensure it's a number
    const selectedBatch = batchOptions.find(
      (option) => option.id === selectedBatchId,
    );

    try {
      const res = await getTotalStudents(selectedBatchId); // assuming API returns students for that batch
      //console.log(res)
      const totalStudentsInBatch = res.data?.[0]?.total_students || 0;

      const batchFull = selectedBatch.strength === totalStudentsInBatch;
      if (res.data?.length === 0) {
        setBatch(selectedBatchId);
        return;
      } else if (selectedBatch.strength > totalStudentsInBatch) {
        //console.log(selectedBatch.strength>totalStudentsInBatch ,'batch deye')
        setBatch(selectedBatchId);
        return;
      } else {
        toast.error('Batch is full');
        setBatch(''); // Reset batch selection
        return;
      }
    } catch (error) {
      console.error('Error checking batch capacity:', error);
      toast.error('Failed to check batch capacity');
    }
  };

  useEffect(() => {
    const Id = userType === 'ad' || userType === 'sa' ? user : admin;
    //console.log(userType)
    getBatch(Id)
      .then((response) => {
        if (response.data) {
          setBatchOptions(response.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching batch options:', error);
      });
  }, [user, userType, admin]);
  //console.log(batch)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', candidateName);
    formData.append('contact', mobileNo);
    formData.append('batch_id', batch);
    formData.append('address', address);
    if (selectedImage) {
      formData.append('photo1', selectedImage);
    }
    if (student) {
      formData.append('id', student.id);
    }
    for (let pair of formData.entries()) {
      //console.log(pair[0]+ ', ' + pair[1]);
    }
    
    try {
      await onSubmit(formData);
      
      toast.success('Form submitted successfully');
    } catch (error) {
      toast.error('Failed to submit form');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" gutterBottom color="green" align="center">
          Student Details Form
        </Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            label="Candidate Name"
            value={candidateName}
            onChange={(e) => setCandidateName(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          <TextField
            label="Mobile No"
            type="tel"
            value={mobileNo}
            onChange={(e) => setMobileNo(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Select Batch</InputLabel>
            <Select
              value={batch}
              label="Select Batch"
              onChange={(e) => {
                onBatchSelect(e);
              }}
              required
            >
              {batchOptions.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {`${option.batch_id} - ${option.course}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            fullWidth
            margin="normal"
            multiline
            minRows={4}
            required
          />
          {imagePreviewUrl && (
            <Box
              sx={{
                flex: 1,
                overflow: 'hidden',
                borderRadius: 2,
                border: '1px solid #ccc',
                p: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f9f9f9',
              }}
              fullWidth
            >
              <img
                src={imagePreviewUrl}
                alt="Preview"
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            </Box>
          )}

<Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2 }}>
  <FormControl fullWidth sx={{ flex: 8 }}>
    <InputLabel>Select Image</InputLabel>
    <Select
      value={selectedImage}
      label="Select Image"
      onChange={handleImageSelect}
      required
    >
      {availableImages.map((img, idx) => (
        <MenuItem key={idx} value={img}>
          {img.split('/').pop()}
        </MenuItem>
      ))}
    </Select>
  </FormControl>

  <Button
    onClick={handleRefresh}
    variant="contained"
    sx={{
      whiteSpace: 'nowrap',
      minHeight: '100%',
      height: '100%', // Ensures the button is the same height as the dropdown
      padding: '15px 20px',
    }}
  >
    Refresh
  </Button>
</Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <GreenButton type="submit" fullWidth>
              Submit
            </GreenButton>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default StudentDetailsForm;
